module.exports = __webpack_public_path__ + "static/media/visibility.536383e2.svg";